import styled from "@emotion/styled";

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  text-align: center;
  padding: 2rem;
`;

export const ErrorCode = styled.h1`
  font-size: 6rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.primary};
  margin: 0;
  line-height: 1;
`;

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin: 1rem 0;
`;

export const Description = styled.p`
  font-size: 1.125rem;
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 500px;
  margin-bottom: 2rem;
`;
